export interface Bonus {
  num: string
  title: string
  lines: string[]
  close: string
}

export const bonuses: Bonus[] = [
  {
    num: '1',
    title: 'Prenatal Exercise Modification Vault™',
    lines: [
      'When an exercise needs to change, don’t start searching.',
      'Access a complete professional vault of movement swaps, regressions, progressions, position alternatives, equipment alternatives and quick modification matrices.',
    ],
    close: 'Find the right alternative without rebuilding the session.',
  },
  {
    num: '2',
    title: '30 Ready-to-Coach Prenatal Sessions™',
    lines: [
      'Need a complete session? Open the library and choose one.',
      'Access 30 complete prenatal fitness sessions covering strength, mobility, conditioning, home, gym, minimal equipment, shorter sessions and lower-energy options.',
    ],
    close: '30 complete sessions ready to adapt and coach.',
  },
  {
    num: '3',
    title: 'Prenatal Coach Communication Toolkit™',
    lines: [
      'Know what to ask, what to monitor, and how to communicate professionally.',
      'Access ready-to-use onboarding scripts, pre-session check-ins, modification conversations, post-session reviews, client messages and professional communication frameworks.',
    ],
    close: 'Professional communication without improvising every conversation.',
  },
  {
    num: '4',
    title: 'Prenatal Coaching Casebook™',
    lines: [
      'See how the complete system works with real coaching situations.',
      'Explore practical client scenarios involving different training backgrounds, changing readiness, exercise modifications, equipment limitations, programming adjustments and professional boundaries.',
    ],
    close: 'See the decision. Understand it. Apply it.',
  },
  {
    num: '5',
    title: 'Prenatal Session Rescue System™',
    lines: [
      'Your planned session doesn’t always survive contact with reality.',
      'Lower energy? Less time? Different equipment? An exercise needs changing?',
      'Access ready-to-use Plan B sessions, shortened structures, exercise blocks and last-minute adaptation systems.',
    ],
    close: 'When the original plan changes, you already have another one.',
  },
]
